import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "w-full"
};
const _hoisted_2 = {
  class: "flex"
};
const _hoisted_3 = {
  class: "ml-auto"
};
const _hoisted_4 = {
  class: "px-4 py-1 my-1 mr-4 bg-white border border-b-4 border-[rgb(var(--v-theme-error))] shadow-sm opacity-80"
};
const _hoisted_5 = {
  class: "ml-4 mr-24"
};
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
export default {
  __name: 'SettingsSaveBar',
  props: {
    saving: {
      type: Boolean,
      required: true
    },
    unsaved: {
      type: Boolean,
      required: true
    },
    somethingChanged: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    },
    showFullWidth: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['cancel', 'update'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const cancel = () => {
      emit('cancel');
    };
    const update = () => {
      emit('update');
    };
    return (_ctx, _cache) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["absolute right-0 bottom-0 p-4 bg-gray-50 left-bar-border-top border-gray-100 flex w-4/5", {
          'w-full': __props.showFullWidth
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[5] || (_cache[5] = _createElementVNode("div", null, null, -1)), _createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("div", _hoisted_4, [...(_cache[2] || (_cache[2] = [_createElementVNode("span", {
        class: "fa fa-exclamation-circle text-error pr-2"
      }, null, -1), _createTextVNode(" You have unsaved changes ", -1)]))], 512), [[_vShow, __props.unsaved]])]), _createVNode(LlSecondaryButton, {
        onBtnClick: _cache[0] || (_cache[0] = $event => cancel()),
        disabled: __props.saving,
        class: "px-12 py-2 mr-4"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode(" Cancel ", -1)]))]),
        _: 1
      }, 8, ["disabled"]), _createElementVNode("div", _hoisted_5, [_createVNode(LlSecondaryButton, {
        id: "save",
        onBtnClick: _cache[1] || (_cache[1] = $event => update()),
        color: "primary",
        variant: "flat",
        disabled: __props.disabled || __props.saving
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode(" Save Settings ", -1)]))]),
        _: 1
      }, 8, ["disabled"])])])])], 2)), [[_vShow, __props.somethingChanged && !__props.saving]]);
    };
  }
};